const { getThresholds, getThresholdRelativeToMOS } = require('../../../forecast/tools/read/psm-thresholds')
const { DAYS_PER_MONTH } = require('../../constants')

function buildCalculationModalData ({
  soh,
  amc: amcInput,
  programId,
  budgetAllocatedQty,
  minLevel,
  reorderPoint,
  maxLevel,
  leadTimeDays
}) {
  const thresholds = getThresholds(programId)
  const { min, reOrder, max } = thresholds

  const hasForecastLevels = maxLevel != null
  const leadTimeMonths = hasForecastLevels
    ? (leadTimeDays != null ? leadTimeDays / DAYS_PER_MONTH : reOrder.months - min.months)
    : reOrder.months - min.months

  const amc = amcInput != null ? amcInput : 0
  const currentSoh = soh != null ? soh : 0

  // Current stock in months (raw for logic, rounded for display)
  let rawStockMonths
  if (amc > 0) {
    rawStockMonths = currentSoh / amc
  } else {
    rawStockMonths = currentSoh > 0 ? 99 : 0
  }
  const currentStockMonths = rawStockMonths === 99
    ? 99
    : parseFloat(rawStockMonths.toFixed(1))

  // Threshold for current stock box
  let threshold
  if (hasForecastLevels) {
    if (currentSoh <= (minLevel || 0)) threshold = 'critical'
    else if (currentSoh <= (reorderPoint || 0)) threshold = 'ok'
    else if (currentSoh <= maxLevel) threshold = 'good'
    else threshold = 'extra'
  } else {
    threshold = getThresholdRelativeToMOS(thresholds, rawStockMonths)
  }

  // Target stock
  const targetMonths = parseFloat((hasForecastLevels
    ? (amc > 0 ? maxLevel / amc : max.months)
    : max.months).toFixed(1))
  const targetStockLevel = hasForecastLevels ? maxLevel : Math.round(amc * targetMonths)

  // Calculation rows
  const leadTimeConsumption = Math.round(amc * leadTimeMonths)
  const effectiveTarget = hasForecastLevels ? maxLevel : Math.round(amc * (targetMonths + leadTimeMonths))
  const suggestedQuantity = effectiveTarget - currentSoh

  // Budget coverage (optional)
  const hasBudgetData = budgetAllocatedQty != null
  let budgetCovers = null
  let budgetResultMonths = null
  if (hasBudgetData) {
    budgetCovers = budgetAllocatedQty
    if (amc > 0) {
      budgetResultMonths = parseFloat(((currentSoh + budgetAllocatedQty) / amc).toFixed(1))
    }
  }

  return {
    currentStockLevel: currentSoh,
    currentStockMonths,
    threshold,
    targetMonths,
    targetStockLevel,
    amc,
    calculation: {
      targetWithBuffer: effectiveTarget,
      currentStockOnHand: currentSoh,
      leadTimeConsumption,
      quantityNeeded: suggestedQuantity,
      budgetCovers,
      budgetResultMonths
    }
  }
}

exports.buildCalculationModalData = buildCalculationModalData
